const fonts = {
  // heading: 'Inter,sans-serif',
  // body: 'Inter,sans-serif',
};

export { fonts };
